/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { FormData } from '../types/common/FormData';

export const removeFormDataEquals = (oldData: FormData, newData: FormData) => {
  return Object.entries(oldData).reduce((aggregate, [key, value]) => {
    if (typeof value === 'object') {
      const diff = removeFormDataEquals(value, newData[key] as FormData);
      if (Object.keys(diff).length) {
        aggregate[key] = diff;
      }
    } else if (value !== newData[key]) {
      aggregate[key] = newData[key];
    }
    return aggregate;
  }, {} as FormData);
};
